// map asset IDs to character names
export const assetIdToCharacter: Record<string, string> = {
  '23000613': 'Shelly',
  '23000614': 'Colt',
  '23000615': 'Spike',
  '23000616': 'Bull',
  '23000617': 'Jacky',
  '23000618': 'Pearl',
}

export const characterIds = Object.keys(assetIdToCharacter)

export const badAssetsBS = ['5000022']
